import React from 'react';

import ContentHeader from '../ContentHeader';
import Title from '../Title';

const BasePage = (props) =>
  <div className="fg1 flex flex-column">
    <ContentHeader links={props.links}>
      <Title>{props.title}</Title>
    </ContentHeader>

    <div className="flex fg1 ph5 dark-gray w-70">
      {props.children}
    </div>
  </div>

export default BasePage;


/** WEBPACK FOOTER **
 ** ./src/components/pages/BasePage.js
 **/